import { createContext, useContext, useEffect, useState } from "react";
const LanguageContext = createContext();

export const useLang = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(
    localStorage.getItem("preferredLanguage") || "en"
  );
  const [country, setCountry] = useState(
    localStorage.getItem("preferredCountry") || "international"
  );

  const handleLanguageChange = (languageCode) => {
    setLang(languageCode);
    localStorage.setItem("preferredLanguage", languageCode);
  };

  const handleCountryChange = (countryCode) => {
    setCountry(countryCode);
    localStorage.setItem("preferredCountry", countryCode);
  };

  useEffect(() => {
    //  document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, country, handleLanguageChange, handleCountryChange }}>
      {children}
    </LanguageContext.Provider>
  );
};
